import React from "react";
import type { RouteObject } from "react-router-dom";

const Landing = React.lazy(() => import("@/page/landing/LandingPage"));
const About = React.lazy(() => import("@/page/about/AboutPage"));
const InstitutionProfile = React.lazy(
  () => import("@/page/institution/InstitutionProfilePage"),
);
const CommunityList = React.lazy(
  () => import("@/page/community/CommunityListPage"),
);
const CommunityDetail = React.lazy(
  () => import("@/page/community/CommunityDetailPage"),
);
const NotFound = React.lazy(() => import("@/page/not-found/NotFoundPage"));
const NcmhGuide = React.lazy(() => import("@/page/guide/NcmhGuidePage"));

export const PublicRoute: RouteObject[] = [
  { index: true, element: <Landing /> },
  { path: "about", element: <About /> },
  { path: "institutions/:slug", element: <InstitutionProfile /> },
  { path: "community", element: <CommunityList /> },
  { path: "community/:idx", element: <CommunityDetail /> },
  { path: "guide", element: <NcmhGuide /> },
  // 공개 그룹 전용 catch-all: 이게 없으면 잘못된 공개 URL이 인증 라우트 그룹의
  // "*" → NotFound 로 흘러가 로그인하지 않은 방문자는 /login 으로 리다이렉트되어 버린다.
  { path: "*", element: <NotFound /> },
];
